import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'CustomerUpdatePipe',
    pure: true
})
export class CustomerUpdatePipe implements PipeTransform {

    private readonly oldValuePattern = /^(\w+)\s+Old Value:\s*(.*)$/;
    private readonly newValuePattern = /^New Value:\s*(.*)$/;

    transform(value: any): any {
        if (!value) {
            return { sections: [] };
        }
        
        const valueStr = value.toString();
        if (!valueStr.includes("Old Value:") || !valueStr.includes("New Value:")) {
            return { sections: [] };
        }
        
        return this.parseCustomerChanges(valueStr);
    }

    private parseCustomerChanges(valueStr: string): any {
        // Check if "Bill To Customer Details" separator exists
        const hasBillToSection = valueStr.includes("Bill To Customer Details");
        
        if (hasBillToSection) {
            // Split by "Bill To Customer Details"
            const parts = valueStr.split("Bill To Customer Details");
            const sellToSection = parts[0].trim();
            const billToSection = parts[1].trim();
            
            return {
                sections: [
                    {
                        title: "lblSellToCustomer",
                        changes: this.parseSection(sellToSection)
                    },
                    {
                        title: "lblBillToCustomer",
                        changes: this.parseSection(billToSection)
                    }
                ]
            };
        } else {
            // Single section without separator
            return {
                sections: [
                    {
                        title: "lblSellToCustomer",
                        changes: this.parseSection(valueStr)
                    }
                ]
            };
        }
    }

    private parseSection(sectionStr: string): any[] {
        const result = [];
        const parts = sectionStr.split('|').filter(part => part.trim());

        let currentField = null;
        let oldValue = '';

        for (const part of parts) {
            const trimmedPart = part.trim();

            if (trimmedPart.includes("Old Value:")) {
                const match = this.oldValuePattern.exec(trimmedPart);
                if (match) {
                    currentField = match[1];
                    oldValue = match[2].trim();
                }
            } else if (trimmedPart.includes("New Value:") && currentField) {
                const match = this.newValuePattern.exec(trimmedPart);
                if (match) {
                    const newValue = match[1].trim();
                    result.push({
                        fieldName: currentField,
                        oldValue: oldValue,
                        newValue: newValue
                    });

                    currentField = null;
                }
            }
        }
        
        return result;
    }
}